import { useEffect, useState } from "react";

import { getCountries } from "api";
import errorToast from "helpers/errorToast";
import { ICountries } from "pages/shipper/RequestForm/components/Schedule/Types";
import { IQuotationData } from "pages/provider/QuotationDetail/QuotationType";
import Pickup from "./Pickup/Pickup";
import Delivery from "./Delivery/Delivery";
import ConfirmationTimer from "./ConfirmationTimer/ConfirmationTimer";
import StopScheduleForm from "./MultiStop/StopScheduleForm";
import StopFlightAndVesselSection from "./MultiStop/StopFlightAndVesselSection";

interface IPickupDeliveryProps {
  quoteRequestDetails: IQuotationData;
  isMultiStop?: boolean;
}

function PickupDelivery(props: IPickupDeliveryProps) {
  const { quoteRequestDetails, isMultiStop } = props;
  const [countries, setCountries] = useState<ICountries[]>([]);

  useEffect(() => {
    getCountries()
      .then((res) => {
        // For now we have to manually remove the country with label "USA" as its causing errors.
        const filteredCountries = res.data.filter((country: ICountries) => country.label !== "USA");
        setCountries(filteredCountries);
      })
      .catch((error) => errorToast(error));
  }, []);

  return (
    <>
      {isMultiStop ? (
        <>
          <StopScheduleForm quoteRequestDetails={quoteRequestDetails} countries={countries} />
          <StopFlightAndVesselSection />
        </>
      ) : (
        <>
          <Pickup quoteRequestDetails={quoteRequestDetails} countries={countries} />
          <Delivery quoteRequestDetails={quoteRequestDetails} countries={countries} />
        </>
      )}
      <ConfirmationTimer quoteRequestDetails={quoteRequestDetails} countries={countries} isMultiStop={isMultiStop} />
    </>
  );
}

export default PickupDelivery;
